// Constantes para solicitações
export const INITIAL_ITEM = {
    item: 1,
    unidade_medida: '',
    descricao: '',
    quantidade: null,
    valor_unitario: null,
};

export const FILE_CONSTRAINTS = {
    maxSize: import.meta.env.VITE_MAX_FILE_SIZE,
    allowedTypes: ['application/pdf'],
    maxSizeMB: import.meta.env.VITE_MAX_FILE_SIZE / 1000000,
};

export const FORM_MESSAGES = {
    success: {
        create: 'Solicitação cadastrada com sucesso',
        update: 'Solicitação atualizada com sucesso'
    },
    error: {
        create: 'Não foi possível cadastrar a solicitação',
        update: 'Não foi possível atualizar a solicitação',
        load: 'Não foi possível carregar os dados'
    },
    warning: {
        alreadyEdited: 'Solicitação já foi editada'
    }
};